import { Component, ElementRef, HostListener, OnInit ,ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ClientSettingsService } from './core/services/auth/client-settings.service';
import { SettingsService } from './core/services/http/maintenance/settings.service';
import liveSession from '@livesession/sdk';
import {
  IframeCommService,
  UserSessionService,
  BnaServicesAuthClientModule,
} from 'bna-angular-auth-client';
import { AppSettings } from './shared/constants/app-settings.constants';
import { JobSearchService } from './core/services/http/maintenance/job-search.service';
import { OrganizationService } from './core/services/http/agency-mgmt/organization.service';
import { JobCacheService } from './job/services/job-detail/job-cache.service';
import { LocalStorageService } from './core/services/data/local-storage.service';
import { SHOWORGANIZATIONEMAILCOUNT } from './shared/constants/local-storage-items.constants';
import { OrganizationSettingsResult } from './shared/models/agency-mgmt/manager.service.model';
import { NotificationService } from './core/services/firebase/notification.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  private _appTheme = '';

  public get appTheme() {
    return this._appTheme || this.clientSettingsService.get(AppSettings.Theme);
  }
  private set appTheme(value) {
    this.clientSettingsService.set(AppSettings.Theme, value);
    this._appTheme = value;
  }

  isShowChatBot : boolean = false;

  constructor(
    public userSessionService: UserSessionService,
    private OrganizationService: OrganizationService,
    private clientSettingsService: ClientSettingsService,
    private iframeCommService: IframeCommService,
    private settingsService: SettingsService,
    private router: Router,
    private route: ActivatedRoute,
    private authClient: BnaServicesAuthClientModule,
    private jobSearchService: JobSearchService,
    private uiContext: JobCacheService,
    private localStorageService: LocalStorageService,
    private notificationService: NotificationService,
    private cdr:ChangeDetectorRef 
  ) {}

  ngOnInit(): void {
    this.authClient.init();
    this.initLiveSession();
    this.userSessionService.isAuthenticated$.subscribe((result) => {
      this.connectToIntercom();
      this.loadAppSettings();
      this.subscribeForMaintenanceRequests();
    });

    this.loadCampaignAgentScript();
  }

  private initLiveSession() {
    liveSession.init(
      environment.livesession.trackId,
      { rootHostname: '.bricksandagent.com' },
      {
        devMode: !environment.livesession.isEnable,
        scriptURL: 'https://cdn.livesession.io/track.js',
      }
    );
    liveSession.newPageView();
  }

  private subscribeForMaintenanceRequests() {
    this.iframeCommService
      .listen<{
        parameters: {
          external_property_id: string;
          external_maintenance_request_id: string;
          action: string;
        };
      }>(['context'])
      .subscribe((context) => {
        console.log(context);
        if (context.parameters?.action === 'new maintenance request') {
          console.log("Property ID: ", context.parameters?.external_property_id);
          setTimeout(() => {
            this.openNewJobPostByPropertyId(context.parameters?.external_property_id)
          }, 1000);
        } else if (context.parameters?.action === 'maintenance request') {
          setTimeout(() => {
            this.openExistingJobByJobNumber(
              context.parameters?.external_maintenance_request_id
            );
          }, 2000);
        }
      });
  }

  private openNewJobPostByPropertyId(propertyId: string) {
    console.log("Property ID in openNewJobPostByPropertyId: ", propertyId);
    //console.log(this.router.url);
    if (!propertyId) return;
    this.router.navigate(['/job/job-post/', propertyId], {queryParams: { isNewMaintenance: true}});
  }

  private openExistingJobByJobNumber(jobNumber: string) {
    if (!jobNumber) return;
    this.jobSearchService.searchJobsByJobNumber(jobNumber).subscribe({
      next: (res) => {
        if (res != null && res.length > 0 && res[0].id) console.log(res[0].id);
        this.router.navigate(['/job/job-detail/', res[0].id]);
      },
      error: () => {},
    });
  }

  private connectToIntercom() {
    const profile = this.userSessionService.getProfile();
    this.OrganizationService.getSettings(
      this.uiContext.currentVersion , true
    ).subscribe((data) => {
      
      this.updateShowOrganizationEmailsettings(data);
      this.isShowChatBot = data?.isEnabledAlexAgentChatBot || sessionStorage.getItem('df-messenger-queryParameters')!= null ;
      if (!data?.cdpSyncUserReferenceId) return;

      const quillEditor = document.querySelector('.ql-editor');
      const editorContent = quillEditor?.innerHTML;
      
      const encodedContent = encodeURIComponent(editorContent);

      var config = {
        app_id: environment.intercom.appId,
        email: profile.email,
        user_id: data?.cdpSyncUserReferenceId,
        alignment: 'left',
        horizontal_padding: 35,
        vertical_padding: 10,
      };

     window.Intercom('boot', {
       ...config,
       custom_attributes: {
         editorContent: encodedContent,
       },
     });
    });
  }

  private loadAppSettings() {
    this.settingsService.getAppSettings().subscribe((d) => {
      if (!d) return;

      this.appTheme = d.styleCode;
    });
  }

  loadCampaignAgentScript() {
    var script = document.createElement('script');
    script.src = `${environment.campaignAgent.scriptUrl}`;
    document.head.appendChild(script);
  }

  updateShowOrganizationEmailsettings(setttings : OrganizationSettingsResult) {
    if (setttings != null && setttings.showOrganizationEmailNotifications )
      this.localStorageService.set(SHOWORGANIZATIONEMAILCOUNT, setttings.showOrganizationEmailNotifications);
    else 
      this.localStorageService.set(SHOWORGANIZATIONEMAILCOUNT, false);
  }
  
  constrainDrag = (point: { x: number; y: number }) => {
    const maxOffset = 50;
    const newY = Math.max(window.innerHeight - 120 - maxOffset, Math.min(point.y, window.innerHeight - 20));
    return { x: window.innerWidth - 120, y: newY };
  };

}
